import { Component, OnInit } from '@angular/core';
import {Master} from '../../../../admin/models/master.interface';
import {KfChartsService} from '../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../models/charts-search.interface';
import {ReturnRateWeeeSystemInfo} from '../../../models/return-rate-weee-system-info.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-return-rate-benchmark',
  templateUrl: './return-rate-benchmark.component.html',
  styleUrls: ['./return-rate-benchmark.component.scss']
})
export class ReturnRateBenchmarkComponent implements OnInit {

  text = 'Return Rate - Benchmark WEEE Forum system values';
  subtitle!: string;
  data!: ReturnRateWeeeSystemInfo;
  years!: number[];
  collectionStreams!: Master[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.kfChartsService.getCollectionStreams().subscribe(data => this.collectionStreams = data);
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears('putonmarket', 'WEEE_SYSTEM_SCHEMA')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[0];
          }
          this.subtitle = search.startYear + ' (%) ';
          this.kfChartsService.getReturnRateWeeeSystem(search)
            .subscribe(response => this.data = response);
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

}
